// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".importingTemplate .setStyle {\n  color: #4283ff;\n}\n.importingTemplate .setStyle .el-form-item__label {\n    color: #4283ff !important;\n}\n", ""]);
// Exports
module.exports = exports;
